import { generateURLByParts } from "../utils/url";

type KeyRecord = Record<string, string | number>;

export const createRoute = <Keys extends KeyRecord>(path: string) => ({
  apply(args: Keys) {
    return generateURLByParts(path, args);
  },
  href(args: Keys) {
    window.location.href = this.apply(args);
  },
  raw() {
    return path;
  },
});
